import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RouteDetectionService {
  isAcdRoute(url: string): boolean {
    return /\/acd-queues\/\d+/.test(url) === true;
  }

  isCallCenterEndUserAgentRoute(url: string): boolean {
    return /\/users\/.*\/call-center\/\d+\/agent\/\d+/.test(url) === true;
  }

  isCallCenterQueueRoute(url: string): boolean {
    return /\/call-center\/\d+\/queues\/\d+/.test(url) === true;
  }

  isCallCenterRoute(url: string): boolean {
    return /\/call-center/.test(url) === true;
  }

  isSiteRoute(url: string): boolean {
    return /\/sites\/[a-zA-Z.0-9]+/.test(url) === true;
  }

  isSystemRoute(url: string): boolean {
    return url.startsWith('/reseller') === false;
  }
}
